import { IRobotOption } from '../models/robot-selector.model';

export interface IPhysicalRequirement {
    payloadKg: number;
    reachMm: number;
}

export function ratedPayloadKg(robot: IRobotOption): number {
    return robot.extendedPayloadKg ?? robot.payloadKg;
}

export function isEligible(robot: IRobotOption, requirement: IPhysicalRequirement): boolean {
    return ratedPayloadKg(robot) >= requirement.payloadKg && robot.reachMm >= requirement.reachMm;
}
